/* eslint-disable */
import moment from "moment-timezone";

export interface FaultRow {
  id: string;
  created_at: string;
  short_msg: string;
  duration: string;
}

// Formats the API may return for date/cleared timestamps
const FAULT_DATE_FORMATS = ["ddd. MMM DD. YYYY - HH:mm:ss", moment.ISO_8601];

/**
 * Return the display value for a fault duration.
 * - If a duration string exists, return it as-is.
 * - If no duration AND no cleared timestamp, the fault is still active.
 * - If no duration but cleared exists, compute from date/cleared timestamps.
 */
function formatElapsed(totalSeconds: number): string {
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  if (days > 0) return `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

export function formatFaultDuration(
  duration: string | null | undefined,
  cleared: string | null | undefined,
  date?: string | null
): string {
  if (duration && duration !== "Active") return duration;
  if (!cleared || cleared === "Active") {
    if (date) {
      const start = moment(date, FAULT_DATE_FORMATS);
      if (start.isValid()) {
        const totalSeconds = Math.floor(moment().diff(start) / 1000);
        if (totalSeconds >= 0) return `Active - ${formatElapsed(totalSeconds)}`;
      }
    }
    return "Active";
  }
  if (date) {
    const start = moment(date, FAULT_DATE_FORMATS);
    const end = moment(cleared, FAULT_DATE_FORMATS);
    if (start.isValid() && end.isValid() && end.isSameOrAfter(start)) {
      const totalSeconds = Math.floor(end.diff(start) / 1000);
      return formatElapsed(totalSeconds);
    }
  }
  return "";
}

/** Build the request body for POST /reports/faults/recent */
export function buildLiftFaultRequestBody(
  liftSelected: { bank_id: string; id: string },
  timezone: string
): object {
  return {
    bank_id: liftSelected.bank_id,
    lift_id: liftSelected.id,
    weeks: 2,
    timezone,
    download: "false",
    limit: 20,
  };
}

/** Map API response items to table rows */
export function buildLiftFaultsData(response: any[]): FaultRow[] {
  return response.map((item: any) => ({
    id: `${item.lift_name}-${item.date}-${item.floor}-${item.detailed_fault}-${item.direction}`,
    created_at: item.date,
    short_msg: item.detailed_fault,
    duration: formatFaultDuration(item.duration, item.cleared, item.date),
  }));
}
